import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import sequencer from './sequencer'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);




class Capsule extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      img: []
    }

  }

  mount() {

    this.bindedchange = this.change.bind(this)
    this.delayedCall = gsap.delayedCall(2.13, this.bindedchange)
         
}

change() {

        this.index = gsap.utils.wrap(0, this.ref.img.length, ++this.i)
        console.log();
        $('.img-visible').removeClass('img-visible')
        this.ref.img[this.index].classList.add("img-visible")
        this.delayedCall = gsap.delayedCall(2.13, this.bindedchange)
 
}

  unmount() {

        
        

  }


}

module.exports = Capsule
